import React, { useState, useEffect } from "react";
import { Row, Container, Col } from "react-bootstrap";
import Footer from "../../stories/Footer";
import Header from "../../stories/Header";
import Input from "../../stories/Input";
import MainCard from "../../stories/MainCard";
import classes from "./CardsPage.module.css";
import SearchIcon from "@mui/icons-material/Search";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import Select from "react-select";
import { PaginationComponent } from "../../stories/Pagination/Pagination";
import { BaseURL, recordsLimit } from "../../config/apiUrl";
import FeaturedCardModal from "../../stories/FeaturedCardModal/FeaturedCardModal";
import NoDataComp from "../../stories/NoDataComp/NoDataComp";
import { Post } from "../../Axios/AxiosFunctions";
import { useDispatch, useSelector } from "react-redux";
import MainCardSkeleton from "../../stories/MainCard/MainCardSkeleton";
import { useLocation } from "react-router-dom";
import { saveLocation } from "../../redux/common/commonSlice";

let isInitialRender = true;

const CardsPage = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  useEffect(() => {
    dispatch(saveLocation(location));
  }, []);

  const stateTag = useLocation()?.state;
  const tagsData = useSelector((state) => state?.commonReducer?.tags);
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
  const [page, setPage] = useState(1);
  const [collectionData, setCollectionData] = useState([]);
  const [isLoadingApiCall, setIsLoadingApiCall] = useState(false);
  const [cardType, setCardType] = useState(options[0]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [search, setSearch] = useState("");
  const [selectedTags, setSelectedTags] = useState(stateTag ? [stateTag] : "");
  const [selectedElemenet, setSelectedElement] = useState(null);

  // getCardData
  const getCardData = async (pageNo, collectionType, searchTerm, tags) => {
    const url = BaseURL(`cards?page=${pageNo}&limit=${recordsLimit}`);
    const params = {
      type: collectionType?.value,
      search: searchTerm,
      ...(selectedTags !== "" &&
        tags?.length !== 0 && { tags: tags?.map((e) => e?._id) }),
    };

    setIsLoadingApiCall(true);
    const response = await Post(url, params);
    setIsLoadingApiCall(false);

    if (response !== undefined) {
      setCollectionData(response?.data?.data);
      setTotalRecords(response?.data?.totalRecords);
    }
  };

  useEffect(() => {
    getCardData(page, cardType, search, selectedTags);
  }, [page, cardType, selectedTags]);

  useEffect(() => {
    let timeout;
    if (isInitialRender) {
      isInitialRender = false;
    } else {
      timeout = setTimeout(() => {
        setPage(1);
        getCardData(1, cardType, search, selectedTags);
      }, 500);
    }

    return () => clearTimeout(timeout);
  }, [search]);

  return (
    <>
      <style>
        {`
        .css-1s2u09g-control{
            border-radius: 25px;
            padding:7px;
            background:var(--primary-color);
            color:white !important;
      
        }
        .css-1pahdxg-control{
            border-radius: 25px !important;
            padding:7px !important;
            background:var(--primary-color) !important;
            border:none;
            color:white !important;
        }
        .css-14el2xx-placeholder{
            color:white;
            font-size: 20px;
            letter-spacing: 1px;
            padding-left: 20px;
        }
        .css-1okebmr-indicatorSeparator{
            background:none;
        }
        .css-6j8wv5-Input{
            color:white;
        }
        .css-tlfecz-indicatorContainer{
            background-image: url(../../assets/images/Polygon.png) !important;
            background-size: 100% 100%;
        }
        .css-tj5bde-Svg{
            display:none;
        }
        .css-qc6sy-singleValue{
            color:white;
            font-size: 20px;
            letter-spacing: 1px;
            padding-left: 20px;
        }
        .css-1pndypt-Input{
            color:white;
            font-size: 20px;
            letter-spacing: 1px;
            padding-left: 20px;
        }
    
        `}
      </style>
      <Header />
      <section>
        <Container className={classes.container}>
          <Row>
            <Col lg={4}></Col>
            <Col className={classes.search_main_column} lg={8}>
              <div className={classes.search_bar}>
                <Input
                  inputContainer={classes.searchInput}
                  type={"text"}
                  placeholder={"Search"}
                  value={search}
                  setter={(e) => setSearch(e)}
                />
                <SearchIcon className={classes.search_icon} />
              </div>
              <div className={classes.featured_dropDown_mainTag}>
                <Select
                  placeholder="Select Tags"
                  options={tagsData}
                  value={selectedTags}
                  getOptionLabel={(op) => op?.name}
                  getOptionValue={(op) => op?.name}
                  onChange={(e) => {
                    setPage(1);
                    setSelectedTags(e);
                  }}
                  isMulti
                />
              </div>

              <div className={classes.featured_dropDown_main}>
                <Select
                  placeholder="Card Type"
                  options={options}
                  value={cardType}
                  onChange={(e) => {
                    setPage(1);
                    setCardType(e);
                  }}
                />
              </div>
            </Col>
          </Row>
          <Row className={classes.featured_heading}>
            <h2>Cards</h2>
          </Row>
          <Row className={classes.CollectionCard_row}>
            {!isLoadingApiCall &&
              collectionData?.map((e, i) => {
                return (
                  <Col
                    className={classes.MainCardCol}
                    xl={3}
                    lg={4}
                    md={6}
                    key={i}
                  >
                    <MainCard
                      key={i}
                      data={e}
                      onClick={() => {
                        setSelectedElement(e);
                        setIsDetailModalOpen(true);
                      }}
                    />
                  </Col>
                );
              })}

            {isLoadingApiCall &&
              Array(8)
                .fill(0)
                .map((e, i) => (
                  <Col lmd={4} xl={3} key={i}>
                    <MainCardSkeleton />
                  </Col>
                ))}
          </Row>
          {totalRecords > recordsLimit && (
            <Row>
              <PaginationComponent
                totalPages={Math.ceil(totalRecords / recordsLimit)}
                setCurrentPage={setPage}
                currentPage={page}
              />
            </Row>
          )}
          {!isLoadingApiCall && collectionData?.length === 0 && (
            <NoDataComp title={"No Card found."} className={classes?.noData} />
          )}
        </Container>
      </section>
      <Footer />
      {selectedElemenet && (
        <FeaturedCardModal
          show={isDetailModalOpen}
          setShow={setIsDetailModalOpen}
          data={selectedElemenet}
        />
      )}
    </>
  );
};

export default CardsPage;

const options = [
  { value: "all", label: "All" },
  { value: "popular", label: "Popular" },
  { value: "featured", label: "Featured" },
  { value: "recent", label: "Recently Added" },
];
